import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import CTAButton from '../buttons/CTAButton';
import './Hero.css';

const Hero = ({
  title,
  subtitle,
  backgroundImage,
  image,
  ctaText,
  ctaLink,
  ctaType = 'link',
  ctaVariant = 'primary',
  ctaMessage,
  height = '500px',
  overlay = true,
  overlayOpacity = 0.3,
  textAlign = 'left',
  contentAlign = 'center'
}) => {
  return (
    <Box className="hero-container" sx={{ minHeight: height, position: 'relative' }}>
      {/* Background Image */}
      {backgroundImage && (
        <Box className="hero-background">
          <img src={backgroundImage} alt="" />
          {overlay && (
            <Box
              className="hero-overlay"
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: `rgba(0, 0, 0, ${overlayOpacity})`,
                zIndex: 1
              }}
            />
          )}
        </Box>
      )}

      {/* Content Container */}
      <Container
        maxWidth="lg"
        sx={{
          position: 'relative',
          zIndex: 2,
          height: '100%',
          display: 'flex',
          alignItems: contentAlign,
          justifyContent: 'space-between',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: 3, md: 5 },
          py: { xs: 4, md: 6 }
        }}
      >
        {/* Text Content */}
        <Box
          className="hero-content"
          sx={{
            flex: 1,
            textAlign: { xs: 'center', md: textAlign },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: 2
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontFamily: '"Reem Kufi", sans-serif',
              fontSize: { xs: 'clamp(2rem, 5vw, 3rem)', md: 'clamp(2.5rem, 5vw, 4rem)' },
              fontWeight: 700,
              color: backgroundImage ? '#fff' : '#1B422E',
              lineHeight: 1.2,
              textShadow: backgroundImage ? '2px 2px 4px rgba(0,0,0,0.5)' : 'none'
            }}
          >
            {title}
          </Typography>

          <Typography
            variant="h2"
            sx={{
              fontFamily: '"Reem Kufi", sans-serif',
              fontSize: { xs: 'clamp(1rem, 3vw, 1.25rem)', md: 'clamp(1.25rem, 3vw, 1.5rem)' },
              fontWeight: 400,
              color: backgroundImage ? '#f0f0f0' : '#505050',
              lineHeight: 1.5,
              textShadow: backgroundImage ? '1px 1px 3px rgba(0,0,0,0.5)' : 'none',
              maxWidth: '600px',
              mx: { xs: 'auto', md: textAlign === 'center' ? 'auto' : 0 }
            }}
          >
            {subtitle}
          </Typography>

          {/* CTA Button */}
          {ctaText && (
            <Box sx={{ mt: 2, textAlign: { xs: 'center', md: textAlign } }}>
              <CTAButton
                text={ctaText}
                type={ctaType}
                href={ctaLink}
                message={ctaMessage}
                variant={ctaVariant}
                size="large"
              />
            </Box>
          )}
        </Box>

        {/* Optional Side Image */}
        {image && (
          <Box
            className="hero-image"
            sx={{
              flex: { xs: 'none', md: 1 },
              maxWidth: { xs: '300px', md: '450px' },
              mx: { xs: 'auto', md: 0 },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <img
              src={image}
              alt={title}
              style={{
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
                filter: 'drop-shadow(2px 2px 10px rgba(0,0,0,0.2))'
              }}
            />
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default Hero;
